import { useAppSelector } from "app/redux/hooks";
import { DetalhesComissoes } from "app/types/comissoes/Indicadores";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { definirIndicador, definirPercentualComissaoDiferenciada } from "app/use-cases/orcamento/comissoes/detalharComissoesPorIndicador";
import globalMU from "globalMU";
import React, { useEffect, useState, useRef } from "react";
import { DetalhesComissao } from "./DetalhesComissao";
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { obterPermissao } from "app/use-cases/obterPermissao";
import microuniversoApi from "app/api/microuniversoApi";
import { atualizarOrcamento } from "app/use-cases/orcamento/atualizarOrcamento";

export const DetalhesComissoesContainer = () => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]) // 469844
    const [processando, setProcessando] = useState(false)
    const [ocorreuDesvio, setOcorreuDesvio] = useState(0)
    const [processadoParametros, setProcessadoParametros] = useState(false) // 443809
    const [indicadoresAcaoProgramaRelacionamento, setIndicadoresAcaoProgramaRelacionamento] = useState(false)
    const [indicadoresAcaoPercentualComissaoDiferenciada, setIndicadoresAcaoPercentualComissaoDiferenciada] = useState(false)
    const [programasDeRelacionamento, setProgramasDeRelacionamento] = useState([])
    
    // isMounted para controle de componentes montados/desmontados
    const isMounted = useRef(true)

    const processosRenderizacaoDependente = async () => {
      const parametrosObtidos = await obterParametros({
          nomes: ["OBRIGATORIO_INFORMAR_INDICADOR_VENDA"], // 443809
        })

      // Verifica se o componente ainda est� montado antes de atualizar o estado
      if (isMounted.current) {
        setParametros(parametrosObtidos)
      }

      const paramPorFilial = await obterParametrosPorOidItem({
        nomes: ["BLOQUEAR_APRESENTACAO_CAMPOS_DO_TRATAMENTO_DE_COMISSAO_POR_INDICACAO", //469844
        
        ],
        oidItem: orcamento.OidFilialOrcamento
      })
      
      // Verifica se o componente ainda est� montado antes de atualizar o estado
      if (isMounted.current) {
        setParametrosPorFilial(paramPorFilial) // 469844
      }

      const permissaoProgramaRelacionamento = await permitidoAcaoFuncionalidade("ORCAMENTO_INDICADORES","INDICADORES_ACAO_PROGRAMA_RELACIONAMENTO")
      const permissaoPercentualComissao = await permitidoAcaoFuncionalidade("ORCAMENTO_INDICADORES","INDICADORES_ACAO_PERCENTUAL_COMISSAO_DIFERENCIADA")

      // Verifica se o componente ainda est� montado antes de atualizar o estado
      if (isMounted.current) {
        setIndicadoresAcaoProgramaRelacionamento(permissaoProgramaRelacionamento)
        setIndicadoresAcaoPercentualComissaoDiferenciada(permissaoPercentualComissao)
      }

      onObterProgramasDeRelacionamento()

      // Verifica se o componente ainda est� montado antes de atualizar o estado
      if (isMounted.current) {
        setProcessadoParametros(true)
      }
    }

    const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) =>
        await obterPermissao({ funcionalidade: siglaFuncionalidade, acao })

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor

    const onAplicarComissao = async (dadosComissoes: DetalhesComissoes) => {
        try {
            globalMU.blockUI();
            setProcessando(true)
            await definirIndicador(dadosComissoes)
            
            // Verifica se o componente ainda est� montado antes de mostrar a mensagem
            if (isMounted.current) {
                globalMU.showSuccessMessage("Indicador definido com sucesso.")
            }
        } catch (e) {
            // Verifica se o componente ainda est� montado antes de tratar o erro
            if (isMounted.current) {
                tratamentoErroPadrao(e);
            }
        } finally {
            // Verifica se o componente ainda est� montado antes de atualizar o estado
            if (isMounted.current) {
                setProcessando(false)
            }
            globalMU.unblockUI();
            
        }
    }  
    
    const onPercentualComissaoDiferenciada = async (valor: number) => {
        try {
            globalMU.blockUI();
            setProcessando(true)
            if (valor < 100 && valor >= 0) {
                await definirPercentualComissaoDiferenciada(valor)
            } else {
                // Verifica se o componente ainda est� montado antes de mostrar a mensagem
                if (isMounted.current) {
                    globalMU.showErrorMessage("Valor Percentual deve ficar entre 0 e 99,99%.")
                    setOcorreuDesvio(ocorreuDesvio+1)
                }
            }
        } catch (e) {
            // Verifica se o componente ainda est� montado antes de tratar o erro
            if (isMounted.current) {
                tratamentoErroPadrao(e);
            }
        } finally {
            // Verifica se o componente ainda est� montado antes de atualizar o estado
            if (isMounted.current) {
                setProcessando(false)
            }
            globalMU.unblockUI();
        }
    }

    const onObterProgramasDeRelacionamento = async () => {
        try {
            globalMU.blockUI();
            const programasDeRelacionamento = await microuniversoApi.Orcamento.obterProgramasDeRelacionamento()
            
            // Verifica se o componente ainda est� montado antes de atualizar o estado
            if (isMounted.current) {
                setProgramasDeRelacionamento(programasDeRelacionamento)
            }
        } catch (e) {
            // Verifica se o componente ainda est� montado antes de tratar o erro
            if (isMounted.current) {
                tratamentoErroPadrao(e);
            }
        } finally {
            globalMU.unblockUI();
        }
    }
    
    useEffect(() => {
      (async () => {
		isMounted.current = true
        await atualizarOrcamento() // 478042
        processosRenderizacaoDependente()
      })()
	  
      return () => {
        isMounted.current = false
      }    
    }, [])

    return (
      <>
      {processadoParametros && // 443809
      <DetalhesComissao 
          processando={processando}
          comissao={orcamento.Indicador} 
          parametrosPorFilial={parametrosPorFilial} // 469844
          onAplicarComissao={onAplicarComissao}
          onPercentualComissaoDiferenciada={onPercentualComissaoDiferenciada} 
          programasDeRelacionamento={programasDeRelacionamento}
          exibirCampoProgramaDeRelacionamento={indicadoresAcaoProgramaRelacionamento}
          exibirCampoPercentualComissaoDiferenciada={indicadoresAcaoPercentualComissaoDiferenciada}
          parametroObrigatorioInformarIndicadorNaVenda={valorParametro("OBRIGATORIO_INFORMAR_INDICADOR_VENDA") == "S"} // 443809
          somenteLeitura={orcamento.SomenteLeitura}
          ocorreuDesvio={ocorreuDesvio} />
      }
      </>
      )
}